// extracted by mini-css-extract-plugin
export default {"wordLogo":"layout_wordLogo__chx6r","collapsible-nav":"layout_collapsible-nav__bulRe","container":"layout_container__vY8Hz","banner":"layout_banner__yntyi"};